import { ApiService } from "pwapi";

import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

import {
  UPDATE_LIS_SLIDE_REQUEST,
  UPDATE_LIS_SLIDE_SUCCESS,
  UPDATE_LIS_SLIDE_FAILURE,
  CREATE_LIS_SLIDE_FAILURE,
  CREATE_LIS_SLIDE_REQUEST,
  CREATE_LIS_SLIDE_SUCCESS,
  DELETE_LIS_SLIDE_FAILURE,
  DELETE_LIS_SLIDE_REQUEST,
  DELETE_LIS_SLIDE_SUCCESS,
} from "../constants";

type updateSlideArgs = Parameters<typeof ApiService.partialUpdateAdminSlide>[0];

// TODO: Missing creation of slide API
type createSlideArgs = Parameters<typeof ApiService.createSlideLis>[0];
type deleteSlideArgs = Parameters<typeof ApiService.destroySlide>[0];

export const updateSlide: AsyncSagaAction<updateSlideArgs> = createAsyncSaga(
  UPDATE_LIS_SLIDE_REQUEST,
  UPDATE_LIS_SLIDE_SUCCESS,
  UPDATE_LIS_SLIDE_FAILURE,
  ({ id }: updateSlideArgs) => `admin/slide/${id}/update`,
  ({ id, requestBody }: updateSlideArgs) =>
    ApiService.partialUpdateAdminSlide({
      id,
      requestBody,
    })
);

// This is exclusively being used to create control Slides
export const createSlide: AsyncSagaAction<createSlideArgs> = createAsyncSaga(
  CREATE_LIS_SLIDE_REQUEST,
  CREATE_LIS_SLIDE_SUCCESS,
  CREATE_LIS_SLIDE_FAILURE,
  () => `admin/slide/create`,
  ({ requestBody }: createSlideArgs) =>
    ApiService.createSlideLis({
      // This should be updated not to use the LIS endpoint
      requestBody,
    })
);

export const deleteSlide: AsyncSagaAction<deleteSlideArgs> = createAsyncSaga(
  DELETE_LIS_SLIDE_REQUEST,
  DELETE_LIS_SLIDE_SUCCESS,
  DELETE_LIS_SLIDE_FAILURE,
  ({ id }: deleteSlideArgs) => `admin/slide/${id}/delete`,
  ({ id }: deleteSlideArgs) =>
    ApiService.destroySlide({
      id,
    })
);
